const utils = require('../../utils')
import constant from '../../store/constant.js'

export default {
  name: 'es-mycard-new',
  data () {
    return {
      card: {},
      showHeadsUpModal: true,
      isCharacter1ImageSelect: false,
      isCharacter2ImageSelect: false,
      isInputMode: false,
      currentCharacter1Tab: 0,
      isInitialized: false,
      loadError: false,
      character1Folder: constant.character1Folder,  // キャラクター1フォルダー構成
      character1Image: constant.character1Image,  // キャラクター1画像
      character2Image: constant.character2Image,  // キャラクター2画像
      character1SwiperOption: {
        on: {
          slideChangeTransitionStart: () => {
            this.currentCharacter1Tab = this.swiper.realIndex
          }
        }
      }
    }
  },
  created: async function () {
    this.isInitialized = false
    this.loadError = false
    if (sessionStorage.getItem('es_mycard_preview_referrer')) {
      sessionStorage.removeItem('es_mycard_preview_referrer')
      // プレビューから戻ってきた時は注意喚起モーダル表示させない
      this.showHeadsUpModal = false
    }
    // 初期表示処理
    try {
      await this.setInitializ()
      this.isInitialized = true
    } catch (err) {
      // 取得に失敗した場合、旧実装は例外で処理が止まり画面が白いままになっていた。
      // 原因を伝えたうえでデザイン選択画面に戻す
      console.error(err)
      if (!this.loadError) {
        this.loadError = true
        alert('通信エラーが発生したニャン。もう一度お試しくださいニャン。')
        this.$router.push({ path: '/select_design' })
      }
    }
  },
  computed: {
    authToken() {
      return localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    },
    // 背景画像パス生成
    getBackgroundImageByImageName () {
      return imageName => {
        return require(`../../../static/mycard/background/${imageName}.png`)
      }
    },
    // プロフィール画像パス生成
    getUserImage () {
      return imagePath => {
        if (imagePath) {
          return `${imagePath}?token=${this.authToken}&timestamp=${this.timeStamp}`
        }
        return require('../images/img_profile.png')
      }
    },
    // キャラクター画像パス生成
    getCharacter1ImageByImageName () {
      return (pathName, imageName) => {
        return require(`../../../static/mycard/character1/${pathName}/${imageName}.png`)
      }
    },
    // キャラクター画像パス生成
    getCharacter2ImageByImageName () {
      return (imageName) => {
        return require(`../../../static/mycard/character2/${imageName}.png`)
      }
    },
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    goCancel: function () {
      // SessionStorageを削除
      sessionStorage.removeItem('es_mycard')
      this.$router.push({ path: '/select_design' })
    },
    goPreview: function () {
      // プレビューの表示内容と実際に登録される内容を一致させるため、
      // ここで保存できない4バイト文字(絵文字)を除去しておく
      this.card.comments = utils.removeEmoji(this.card.comments)
      // 配列をSessionStorageに保持
      sessionStorage.setItem('es_mycard', JSON.stringify(this.card))
      sessionStorage.setItem('es_mycard_preview_referrer', this.$router.history.current.path)
      this.$router.push({ path: '/es_mycard/preview' })
    },
    setClassIdea: function (idea) {
      // 理念を選択時のスタイルを変更する
      if (eval('this.card.' + idea)) {
        return '-on'
      } else {
        return ''
      }
    },
    setClassHeaderCharacter2Select: function () {
      // キャラクター２選択時は、ヘッダーを固定させない
      if (this.isCharacter2ImageSelect) {
        return 'fixed_reset'
      } else {
        return ''
      }
    },
    setClassWrapperCharacter2Select: function () {
      // キャラクター２選択時は、ヘッダーを固定させない
      // 固定するときは、ヘッダーの高さ分の余白クラスを付与する
      if (!this.isCharacter2ImageSelect) {
        return 'pt-header65'
      } else {
        return ''
      }
    },
    setClassCurrentCharacter1ImageTab: function (index) {
      // 選択されたタブにクラス付与する
      if (this.currentCharacter1Tab === index) {
        return 'active'
      }else{
        return ''
      }
    },
    setClassCommentFontSize: function () {
      // 入力された文字によってスタイル変更
      if (this.card.comments.length <= 50) {
        return 'big'
      }
      if (this.card.comments.length <= 80) {
        return 'middle'
      }
      if (this.card.comments.length <= 140) {
        return 'small'
      }
    },
    setClassCharacter1Scroll: function (images) {
      // 選択する画像が6枚より多い時
      if (images.length > 6) {
        return 'scroll'
      } else {
        return ''
      }
    },
    setIdea: function (idea) {
      // 選択された理念を保持
      if (eval('this.card.' + idea)) {
        eval('this.card.' + idea + '= null')
      } else {
        eval('this.card.' + idea + '= 1')
      }
    },
    setDisplayInit: function () {
      this.isCharacter1ImageSelect = false  // 画像選択非表示
      this.isCharacter2ImageSelect = false  // 画像選択非表示
      this.isInputMode = false              // 入力モード解除
    },
    character1ImageSelect: function () {
      // 画面表示状態初期化
      this.setDisplayInit()
      // キャラクター1画像選択
      this.isCharacter1ImageSelect = !this.isCharacter1ImageSelect
      // スクロールの位置制御
      scrollTo(0, 0)
    },
    character2ImageSelect: function () {
      // 画面表示状態初期化
      this.setDisplayInit()
      // キャラクター2画像選択
      this.isCharacter2ImageSelect = !this.isCharacter2ImageSelect
      // スクロールの位置制御
      scrollTo(0, 435)
      // 画面サイズに合わせて、キャラクター２の表示領域（高さ）動的設定
      const elementPhilosophy = document.getElementById('philosophy')
      const hPhilosophy = elementPhilosophy.clientHeight
      const elementMainList = document.getElementById('main_list')
      elementMainList.style.height = `${hPhilosophy}px`
    },
    setCurrentCharacter1Image: function (folderPath, path) {
      this.card.character_1_folder_path = folderPath
      this.card.character_1_path = path
      // 画面表示状態初期化
      this.setDisplayInit()
    },
    setCurrentCharacter2Image: function (path) {
      this.card.character_2_path = path
      // 画面表示状態初期化
      this.setDisplayInit()
    },
    setCurrentCharacter1Tab: function (index) {
      // 選択されたタブを保持
      this.currentCharacter1Tab = index
      // 選択されたスライドまで移動させる
      this.swiper.slideTo(index)
    },
    setInitializ: async function () {

      // ベースデザイン選択、送る人情報をSessionStorageから取得
      const cardPreviousData = JSON.parse(sessionStorage.es_mycard)

      // あげた人の店舗情報取得
      const giveUserParam = {
        shop_id: localStorage.shop_id
      }
      // 旧実装はエラーを握りつぶしてundefinedのまま後続処理に進んでいたため、
      // 通信に失敗すると例外で処理が止まり、画面が白いままになっていた
      const giveUserData = await this.$store.dispatch('GET_SHOP_NAME', { data: giveUserParam })
      this.card = {
        get_user_id: cardPreviousData.get_user_id,
        get_user_image: cardPreviousData.get_user_image,
        get_user_shop_name: cardPreviousData.get_user_shop_name,
        get_user_name: cardPreviousData.get_user_name,
        give_user_id: localStorage.user_id,
        give_user_image: localStorage.profile_image_path,
        give_user_shop_name: (giveUserData && giveUserData.shop_name) ? giveUserData.shop_name.shop_name : '',
        give_user_name: localStorage.user_name,
        background_path: cardPreviousData.background_path,
        character_1_folder_path: cardPreviousData.character_1_folder_path,
        character_1_path: cardPreviousData.character_1_path,
        character_2_path: cardPreviousData.character_2_path,
        comments: (cardPreviousData.comments)? cardPreviousData.comments: '',
        idea_peace_ming: (cardPreviousData.idea_peace_ming)? cardPreviousData.idea_peace_ming: '',
        idea_sincere: (cardPreviousData.idea_sincere)? cardPreviousData.idea_sincere: '',
        idea_excitement: (cardPreviousData.idea_excitement)? cardPreviousData.idea_excitement: '',
        idea_comfortable: (cardPreviousData.idea_comfortable)? cardPreviousData.idea_comfortable: '',
        idea_creation: (cardPreviousData.idea_creation)? cardPreviousData.idea_creation: '',
        idea_civility: (cardPreviousData.idea_civility)? cardPreviousData.idea_civility: '',
        idea_imagination: (cardPreviousData.idea_imagination)? cardPreviousData.idea_imagination: '',
        idea_sympathy: (cardPreviousData.idea_sympathy)? cardPreviousData.idea_sympathy: '',
        idea_expression: (cardPreviousData.idea_expression)? cardPreviousData.idea_expression: '',
        idea_challenge_dream: (cardPreviousData.idea_challenge_dream)? cardPreviousData.idea_challenge_dream: ''
      }
    },
    rmEmoji: function(text) {
      // 変化があった時だけ書き戻す（日本語入力中に値を上書きしないため）
      const removed = utils.removeEmoji(text)
      if (removed !== this.card.comments) {
        this.card.comments = removed
      }
    },
    setInputMode: function () {
      // 入力モード
      this.isInputMode = !this.isInputMode
      this.$nextTick(() => {
        // フォーカス
        this.$refs.esMycardComment.focus()
      })
    },
    notInput: function () {
      // 入力チェック：コメント＆理念
      if (this.card.comments && this.isInputedIdeas()) {
        return false
      } else {
        return true
      }
    },
    isInputedIdeas: function () {
      // 入力チェック：理念
      if (this.card.idea_peace_ming ||
          this.card.idea_sincere ||
          this.card.idea_excitement ||
          this.card.idea_comfortable ||
          this.card.idea_creation ||
          this.card.idea_civility ||
          this.card.idea_imagination ||
          this.card.idea_sympathy ||
          this.card.idea_expression ||
          this.card.idea_challenge_dream) {
        return true
      } else {
        return false
      }
    },
    saveDraft: function () {
      this.card.comments = utils.removeEmoji(this.card.comments)
      const draftData = {
        get_user_id: this.card.get_user_id,
        get_user_image: this.card.get_user_image,
        get_user_shop_name: this.card.get_user_shop_name,
        get_user_name: this.card.get_user_name,
        is_facing_type: 0,
        is_already_read: 0,
        background_path: this.card.background_path,
        character_1_folder_path: this.card.character_1_folder_path,
        character_1_path: this.card.character_1_path,
        character_2_path: this.card.character_2_path,
        comments: this.card.comments,
        idea_peace_ming: this.card.idea_peace_ming,
        idea_sincere: this.card.idea_sincere,
        idea_excitement: this.card.idea_excitement,
        idea_comfortable: this.card.idea_comfortable,
        idea_creation: this.card.idea_creation,
        idea_civility: this.card.idea_civility,
        idea_imagination: this.card.idea_imagination,
        idea_sympathy: this.card.idea_sympathy,
        idea_expression: this.card.idea_expression,
        idea_challenge_dream: this.card.idea_challenge_dream
      }
      localStorage.setItem('es_mycard_draft', JSON.stringify(draftData))
      alert('下書きを保存しました')
      this.$router.push({ path: '/' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/es-mycard-new.js